export default __webpack_public_path__ + "static/ave3-663ab4ba540b025f0d6f2b4f7c58c700.jpg";